import * as React from 'react';
import { useLanguage } from '../../locale';
import { useSearchFilters } from './useSearchFilters';
export var useFodMapsFilterSectionFacade = function () {
    var t = useLanguage()[0];
    var _a = React.useState(), fodMapsFilterOption = _a[0], setFodMapsFilterOption = _a[1];
    var _b = useSearchFilters(), setIsFodMapsToFilter = _b.setIsFodMapsToFilter, selectedIsFodMapsFilter = _b.selectedIsFodMapsFilter;
    var options = React.useMemo(function () {
        return [
            {
                type: 'default',
                label: "".concat(t('yes')),
                value: true,
            },
            {
                type: 'default',
                label: "".concat(t('filters.indifferent')),
                value: false,
            },
        ];
    }, [t]);
    React.useEffect(function () {
        if (selectedIsFodMapsFilter === null) {
            setFodMapsFilterOption(null);
        }
        else {
            var fodMapsOptionToSet = options.find(function (o) { return o.value === selectedIsFodMapsFilter; });
            setFodMapsFilterOption(fodMapsOptionToSet !== null && fodMapsOptionToSet !== void 0 ? fodMapsOptionToSet : null);
        }
    }, [options, selectedIsFodMapsFilter]);
    var reset = React.useCallback(function () {
        setFodMapsFilterOption(null);
        setIsFodMapsToFilter(null);
    }, [setIsFodMapsToFilter]);
    var applyFilter = React.useCallback(function () {
        var _a;
        setIsFodMapsToFilter((_a = fodMapsFilterOption === null || fodMapsFilterOption === void 0 ? void 0 : fodMapsFilterOption.value) !== null && _a !== void 0 ? _a : null);
    }, [fodMapsFilterOption, setIsFodMapsToFilter]);
    return {
        options: options,
        fodMapsFilterOption: fodMapsFilterOption,
        setFodMapsFilterOption: setFodMapsFilterOption,
        reset: reset,
        applyFilter: applyFilter,
    };
};
